export interface UserProfile {
    firstname: string;
    lastname: string;
    // uuid: string,
    // buyData:Array<any>,
    // dbs?:Array<string>,

    alertGroup: Array<string>;
    callNumber: string;
    role: Role;
}

export enum Role{
    empty =       '',
    all =         'All',
    alertOnly =   'Alert',
    supportOnly = 'Support',
    TechnicOnly = 'Technic',
    relationOnly = 'Angehörige'
}

export class UserProfile implements UserProfile {
    firstname = '';
    lastname = '';
    role  = Role.empty;
    alertGroups = [];
    // buyData = new Array();
    callNumber = '';
    constructor(){}
}
